/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Match_Col_CodeInputs */

const cs_import_match_col_code = /** @type {(inputs: Import_Match_Col_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kód`)
};

const en_import_match_col_code = /** @type {(inputs: Import_Match_Col_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code`)
};

/**
* | output |
* | --- |
* | "Code" |
*
* @param {Import_Match_Col_CodeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_match_col_code = /** @type {((inputs?: Import_Match_Col_CodeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Match_Col_CodeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_match_col_code(inputs)
	return cs_import_match_col_code(inputs)
});